// ThreadListItem
import ClassNames from 'classnames';
import Moment from 'moment';
import React from 'react';
import { Watch } from 'scrollmonitor-react';
import { connect } from 'react-redux';

import DomUserPicture from './DomUserPicture.jsx';
import { getTranslator } from '../locales';
import { deleteThread } from '../redux/actions/threadsAction';
import { toggleThreadFollow } from '../redux/actions/luserAction';

@connect((Store) => {
  const t = getTranslator();

  return {
    labels: {
      CREATED_AT: t.t('created at'),
      DELETE: t.t('Delete'),
      FOLLOW: t.t('Follow'),
      F_UNANSWERED: t.t('Unanswered'),
      T_JUST_NOW: t.t('just now'),
      UNFOLLOW: t.t('Unfollow'),
      UPDATED_AT: t.t('updated at'),
    },
    luser: Store.luser,
    followedThreadIds: Store.luser.followedThreadIds,
    whichToolboxOpened: Store.threads.whichToolboxOpened
  }
})

export default Watch(class ThreadListItem extends React.Component {
  /**
   * Capture viewport state
   *
   * @param  {object} prevProps Previous props
   * @param  {object} prevState Previous state
   */
  componentDidUpdate(prevProps, prevState) {
    const threadContainerId = this.getThreadContainerId();
    if (this.props.thread.read) {
      // Element is read
      if (this.props.isInViewport) {
        // Element in viewport => we remove it from target list
        // We certainly scrolled to this element, it was unread and out of
        // viewport before.
        this.props.removeScrollBannerTarget(threadContainerId);
      }
    } else {
      if (this.props.isInViewport) {
        // Element in viewport
        // We remove it from target list
        this.props.removeScrollBannerTarget(threadContainerId);
      } else {
        // Element out of viewport
        // Below
        if (this.props.isBelowViewport) {
          this.props.addScrollBannerTarget('bottom', threadContainerId);
        }

        // Above
        if (this.props.isAboveViewport) {
          this.props.addScrollBannerTarget('top', threadContainerId);
        }
      }
    }
  };

  /**
   * Build and get the id of the HTML container for a thread item.
   * @return {string} Thread container id
   */
  getThreadContainerId() {
    return `thread-${this.props.thread.sessionId}-${this.props.thread.id}`;
  }

  handleClick(e) {
    this.props.handleClick(this.props.thread.id);
  }

  handleActionClick(thread_id, e) {
    e.preventDefault();
    this.props.handleToggleToolbox(thread_id);
  }

  handleToggleFollow(thread_id, e) {
    e.preventDefault();
    this.props.dispatch(toggleThreadFollow(thread_id));
  }

  handleDelete(thread_id, e) {
    e.preventDefault();
    this.props.dispatch(deleteThread(thread_id));
  }

  isSelected(threadId, toolboxed = false, withDeleteButton = false) {
    return {
      'threads-list-item': true,
      toolboxed,
      withDeleteButton,
      selected: this.props.isSelected,
      brandedColor_border: this.props.isSelected,
      followed: this.props.followedThreadIds.indexOf(threadId) >= 0,
      unanswered: (
        this.props.luser.insider
        && (this.props.thread.unanswered == 'true' || this.props.thread.unanswered === true)
      ),
      read: this.props.thread.read
    }
  }

  render() {
    const mineClass = (this.props.luser.id === this.props.thread.author.id) ? ' mine brandedColor_color' : '';
    const itemClass = ClassNames(this.isSelected(
      this.props.thread.id,
      (this.props.whichToolboxOpened == this.props.thread.id),
      this.props.luser.insider
    ));

    const messagesCount = (this.props.thread.numberOfMessages ? this.props.thread.numberOfMessages : 0);
    const messagesCountClassName = ClassNames({
      'counter': true,
      'highlighted': !this.props.thread.read,
      'brandedColor_border': true,
      'brandedColor_bg': (this.props.thread.read !== true ? true : false),
    });
    let modifiedSince = Moment().diff(this.props.thread.touchedAt, 'minutes');

    if (modifiedSince < 1) {
      modifiedSince = this.props.labels.T_JUST_NOW;
    } else {
      modifiedSince = Moment.duration(- modifiedSince, 'minutes').humanize(true);
    }

    const modifiedLabel = (this.props.thread.touchedAt === this.props.thread.createdAt) ? this.props.labels.CREATED_AT : this.props.labels.UPDATED_AT;
    const modifiedAt = `${modifiedLabel} ${Moment(this.props.thread.touchedAt).format('LT')}`;

    return (
      <div className={itemClass} id={this.getThreadContainerId()}>
        <div className="content" onClick={this.handleClick.bind(this)}>
          <div className="picture">
            <DomUserPicture user={this.props.thread.author} size='s' />
            <span className={messagesCountClassName}>{messagesCount}</span>
          </div>

          <div className="titleBox">
            <div className="titleHeader">
              <span className={"author" + mineClass}>{this.props.thread.author.name}</span>
              <span className="date" title={modifiedAt}>{modifiedSince}</span>
              <div className="clear"></div>
            </div>
            <div className="title">{this.props.thread.question}</div>
          </div>
          <div className="clear"></div>
        </div>
        <div className='actions' onClick={this.handleActionClick.bind(this, this.props.thread.id)}>
          <div className='toolboxer'>
            <button className='more brandedColor_color_hover'>...</button>
            <button className='star pe-7s-star brandedColorLight_color'></button>
          </div>
          <ul className='toolbox'>
            <li
              className='follow brandedColor_color_hover'
              title={(this.props.followedThreadIds.indexOf(this.props.thread.id) >= 0) ? this.props.labels.UNFOLLOW : this.props.labels.FOLLOW}
              onClick={this.handleToggleFollow.bind(this, this.props.thread.id)}
            >
              <i className='pe-7s-star'></i>
              <label>{(this.props.followedThreadIds.indexOf(this.props.thread.id) >= 0) ? this.props.labels.UNFOLLOW : this.props.labels.FOLLOW}</label>
            </li>
            {
              (() => {
                if (this.props.luser.insider) {
                  return <li className='delete brandedColor_color_hover'
                    title={this.props.labels.DELETE}
                    onClick={this.handleDelete.bind(this, this.props.thread.id)}>
                      <i className='pe-7s-trash'></i>
                      <label>{this.props.labels.DELETE}</label>
                    </li>
                }
              })()

            }
          </ul>
          {
            (() => {
              if (this.props.luser.insider
                && (
                  this.props.thread.unanswered == 'true'
                  || this.props.thread.unanswered === true)
              ) {
                return <div className="attention">
                    <i title={this.props.labels.F_UNANSWERED.toLowerCase()} className="pe-7s-attention"></i>
                  </div>
              }
            })()
          }
        </div>
        <div className='clear'></div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/ThreadListItem.jsx